// Api Yarn Focus : 3004
import axios from "axios";
import { setupInterceptors } from "../modules/auth/services/tokenManager";
import { YARN_FOCUS_API_URL } from "../constants/config";
export const apiClient = axios.create({
  baseURL: YARN_FOCUS_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
setupInterceptors(apiClient, YARN_FOCUS_API_URL);
